<template>
  <div ref="mapContainer" style="width: 100%; height: 300px"></div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  name: "AMapLoader",
  data() {
    return {
      map: null, 
      marker: null, 
      loaded: false,
      infoWindow: null, 
    };
  },

  mounted() {
    this.initMap(); 
  },

  methods: {
    async initMap() {
      try {
        const AMap = await AMapLoader.load({
          key: "WT2BZ-R4BEB-5XWUG-J7VSY-PTYTE-YDBHU", 
          version: "1.4.15", 
          plugins: ["AMap.Marker", "AMap.InfoWindow"], 
        });

        this.map = new AMap.Map(this.$refs.mapContainer, {
          center: [110.516398, 19.213315],
          zoom: 15,
        });

        this.addMarker(AMap); 
      } catch (e) {
        console.error("地图加载失败: ", e);
      }
    },

    addMarker(AMap) {
      this.marker = new AMap.Marker({
        position: [110.516398, 19.213315],
      });

      this.marker.setMap(this.map);

      this.infoWindow = new AMap.InfoWindow({
        content: "琼海长养康宁医院附近", 
        offset: new AMap.Pixel(0, -30),
      });

      this.marker.on("click", () => {
        this.infoWindow.open(this.map, this.marker.getPosition());
      });
    },
  },
};
</script>

<style scoped>
/* 样式可根据需求调整 */
</style>
